<template>
    <div :class="containerClass">
        <h2 :class="titleClass">{{ title }}</h2>
        <p
            v-if="subtitle !== null"
            :class="subtitleClass"
        >
            {{ subtitle }}
        </p>
    </div>
</template>

<script setup lang="ts">
    interface FeaturePageSectionHeaderProps {
        title: string
        subtitle?: string | null
        containerClass?: string
        titleClass?: string
        subtitleClass?: string
    }

    withDefaults(defineProps<FeaturePageSectionHeaderProps>(), {
        subtitle: null,
        containerClass: '',
        titleClass: 'text-3xl font-bold tracking-tight',
        subtitleClass: 'mt-3 max-w-3xl text-slate-600',
    })
</script>
